const backTopBtn = document.querySelector('.js-back-to-top');

if (backTopBtn) {
	backTopBtn.addEventListener('click', () => {
		window.scroll({
			behavior: 'smooth',
			top: 0,
		});
	});
}
